import * as React from 'react';
import {
   AddColumnAfterMenuItem,
   AddColumnBeforeMenuItem,
   AddRowAfterMenuItem,
   AddRowBeforeMenuItem,
   MergeOrSplitMenuItem,
} from './buttons';
import { Menu, MenuButton, MenuList, IconButton, Tooltip } from '@chakra-ui/react';
import { tiptapButtonStyle } from './TiptapButton';
import { useEditorContext } from '../editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { useLocalization } from '~/framework';
import { shadow } from '@dozuki/web-js/primitives';

export const TableCellDropdown = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <Menu onClose={() => setTimeout(() => editor.commands.focus(), 50)}>
         <Tooltip placement="top-start" label={_js('Edit Cell')}>
            <MenuButton
               as={IconButton}
               icon={<FontAwesomeIcon icon={faTable} />}
               // @ts-ignore (MenuButton is missing a TS definition for the rightIcon prop)
               // See https://github.com/chakra-ui/chakra-ui/issues/231
               rightIcon={<FontAwesomeIcon icon={faChevronDown} />}
               padding={1}
               {...tiptapButtonStyle}
            />
         </Tooltip>
         <MenuList minW="auto" padding={0} boxShadow={shadow[3]}>
            <AddColumnAfterMenuItem />
            <AddColumnBeforeMenuItem />
            <AddRowAfterMenuItem />
            <AddRowBeforeMenuItem />
            <MergeOrSplitMenuItem />
         </MenuList>
      </Menu>
   );
};
